import {
  LuCamera,
  LuCircleAlert,
  LuCircleCheck,
  LuRefreshCcw,
} from "react-icons/lu";
import React, { useEffect, useCallback } from "react";
import ReactDOM from "react-dom";
import { RDCModalHTML } from "./RDCModalHTML";
import { Spinner } from "react-bootstrap";

export const RDCSlot = ({
  value = "",
  onChange = () => {},
  side = "",
  error = false,
  checked = false,
  checkedError = false,
  loading = false,
  componentId = "",
  disabled = false,
}) => {
  const title = sides[side];
  const handleMessage = useCallback(
    (event) => {
      if (event.data.event === "check-image-captured" && event.data.data) {
        const { data, side: sideFromEvent } = event.data.data || {};
        if (sideFromEvent === side) {
          onChange(data);
        }
      }
    },
    [onChange, side]
  );

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [handleMessage]);

  const handleClick = () => {
    // Create a temporary div to render the component
    const tempDiv = document.createElement("div");
    const r = <RDCModalHTML side={side} />;

    // Render the component to get its HTML representation
    ReactDOM.render(r, tempDiv);

    // Now we have the rendered HTML in tempDiv
    const renderedHTML = tempDiv.innerHTML;
    // Send the rendered HTML to the parent window
    window.parent.postMessage(
      {
        event: "open-modal-to-capture-check" + componentId,
        data: {
          html: renderedHTML,
          side,
        },
      },
      "*"
    );
  };
  return (
    <>
      <button
        onClick={handleClick}
        disabled={disabled}
        style={{
          border: "none",
          background: "transparent",
          width: "100%",
          height: "100%",
          padding: "0",
          borderRadius: "5px",
          cursor: disabled ? "not-allowed" : "pointer",
        }}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            aspectRatio: "4/2",
            width: "100%",
            alignItems: "start",
            justifyContent: "start",
            backgroundColor: "white",
            borderRadius: "5px",
          }}
        >
          {!value ? (
            <div
              style={{
                position: "relative",
                display: "flex",
                aspectRatio: "4/2",
                width: "100%",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                outline: "none",
                border: error
                  ? "1px dashed rgb(206, 54, 54)"
                  : !disabled ? "1px dashed gray" : "1px dashed #d4d4d4",
                borderRadius: "5px",
                backgroundColor: "transparent",
                padding: "20px",
              }}
            >
              <LuCamera size={24} />
              <span style={{ fontSize: "12px" }}>{title}</span>
            </div>
          ) : (
            <img
              src={value}
              alt="Captured check"
              style={{
                height: "100%",
                width: "100%",
                objectFit: "contain",
                objectPosition: "center",
                borderRadius: "5px",
              }}
            />
          )}
          {loading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                borderRadius: "5px",
                height: "100%",
                backgroundColor: "rgba(58, 58, 58, 0.7)",
              }}
            >
              <Spinner animation="border" variant="light" role="status" />
            </div>
          )}

          {checkedError && !loading && (
            <div
              style={{
                position: "absolute",
                left: "1px",
                top: "1px",
                display: "flex",
                height: "100%",
                width: "calc(100% - 2px)",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "5px",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                color: "white",
                transition: "all",
              }}
              className="hover:bg-black/60"
            >
              <LuRefreshCcw size={24} />
              <small>Take the photo again</small>
            </div>
          )}

          <div>
            {(() => {
              if (checked) {
                if (!checkedError) {
                  return (
                    <span
                      style={{
                        position: "absolute",
                        display: "flex",
                        alignItems: "center",
                        zIndex: 1000,
                        gap: "4px",
                        paddingInline: "4px",
                        fontSize: "10px",
                        borderRadius: "4px",
                        top: 0,
                        transform: "translateY(-50%)",
                        right: 0,
                        color: "hsl(88 61% 20%)",
                        backgroundColor: "hsl(81 88% 80%)",
                      }}
                    >
                      <LuCircleCheck size={12} />
                      Image accepted
                    </span>
                  );
                } else {
                  return (
                    <span
                      style={{
                        position: "absolute",
                        display: "flex",
                        alignItems: "center",
                        zIndex: 1000,
                        gap: "4px",
                        paddingInline: "4px",
                        fontSize: "10px",
                        borderRadius: "4px",
                        top: 0,
                        transform: "translateY(-50%)",
                        right: 0,
                        backgroundColor: "rgb(254, 202, 202)",
                        color: "rgb(127, 29, 29)",
                      }}
                    >
                      Image not accepted
                    </span>
                  );
                }
              }
            })()}
          </div>
        </div>
      </button>
      {error && !checkedError && !loading && (
        <span
          style={{
            fontSize: "10px",
            color: "rgb(153, 0, 15)",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            marginTop: "4px",
            paddingLeft: "4px",
          }}
        >
          <LuCircleAlert size={12} />
          Image is required or not valid
        </span>
      )}
    </>
  );
};

const sides = {
  front: "Front side",
  back: "Back side",
};
